import { defineComponent } from 'vue';
import { hasFlag } from './helpers.mjs';

const items = 1;
const sorted = 3;
const Sorted = sorted;
var ProviderParentMixin = (itemName, flags = 0) => {
    const mixin = defineComponent({
        provide() {
            return {
                ['o' + itemName]: this
            };
        }
    });
    if (hasFlag(flags, items)) {
        mixin.data = function () {
            return {
                childItems: [],
                sequence: 1
            };
        };
        mixin.methods = {
            _registerItem(item) {
                this.$nextTick(() => {
                    item.index = this.childItems.length;
                    this.childItems.push(item);
                });
            },
            _unregisterItem(item) {
                this.$nextTick(() => {
                    this.childItems = this.childItems.filter((i) => i !== item);
                    let index = 0;
                    this.childItems.forEach(it => {
                        it.index = index++;
                    });
                });
            },
            _nextSequence() {
                return this.sequence++;
            }
        };
        if (hasFlag(flags, sorted)) {
            mixin.computed = {
                /**
                 * When items are added/removed sort them according to their position
                 */
                sortedItems() {
                    return this.childItems.slice().sort((i1, i2) => {
                        return i1.index - i2.index;
                    });
                }
            };
        }
    }
    return mixin;
};

const sorted$1 = 1;
const optional = 2;
const Sorted$1 = sorted$1;
var InjectedChildMixin = (parentItemName, flags = 0) => {
    const mixin = defineComponent({
        inject: {
            parent: { from: 'o' + parentItemName }
        },
        created() {
            this.newValue = typeof this.value === 'undefined' ? this.parent._nextSequence() : this.value;
            if (!this.parent) {
                if (!hasFlag(flags, optional)) {
                    throw new Error('You should wrap ' + this.$options.name + ' in a ' + parentItemName);
                }
            }
            else if (this.parent._registerItem) {
                this.parent._registerItem(this);
            }
        },
        beforeUnmount() {
            if (this.parent && this.parent._unregisterItem) {
                this.parent._unregisterItem(this);
            }
        }
    });
    if (hasFlag(flags, sorted$1)) {
        mixin.data = () => {
            return {
                index: null
            };
        };
    }
    return mixin;
};

export { InjectedChildMixin as I, ProviderParentMixin as P, Sorted as S, Sorted$1 as a };
